import React, { useMemo } from 'react';

import { useIntl } from 'react-intl';
import { TileLayer } from 'react-leaflet';

import { messageIdConcat } from '@utils/message-id-concat';
import { messageToString } from '@utils/message';

type Props = {
  satellite: boolean;
  parcels: boolean;
};

const m = messageIdConcat('atlas.map');

export const MapTileLayers = ({ satellite, parcels }: Props) => {
  const intl = useIntl();

  const satelliteMapAttribution = useMemo(() => {
    return `Map data &copy; ${new Date().getFullYear()} Google | <a href="https://www.google.cz/help/terms_maps" target="_blank">${messageToString(
      { id: m('attribution.terms') },
      intl,
    )}</a> | <a href="https://policies.google.com/privacy?hl=cs" target="_blank">${messageToString(
      { id: m('attribution.privacy') },
      intl,
    )}</a>`;
  }, [intl]);

  return (
    <>
      {satellite ? (
        <>
          <TileLayer
            attribution={satelliteMapAttribution}
            url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
          />
        </>
      ) : (
        <>
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png"
          />
          <TileLayer url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png" />
        </>
      )}

      {parcels && (
        <TileLayer url="https://tiles.reas.cz/styles/atlas-parcels/{z}/{x}/{y}@2x.png" />
      )}
    </>
  );
};
